export const ControlStashConfig = Object.freeze({
  ControlPosX: 20,
  ControlPosY: 5,
  StashPosX: 140,
  StashPosY: 5,

  ControlItemWidth: 120,
  ControlItemTextPadding: 10,
  ControlMaxTextWidth: 95,
  ControlMaxTextHeight: 125,
  ControlItemCornerRadius: 5,

  StashItemHeight: 15,
  StashItemTextPadding: 10,
  StashMaxTextWidth: 95,
  StashMaxTextHeight: 30,
  StashItemCornerRadius: 5,

  ShowMoreButtonWidth: 80,
  ShowMoreButtonHeight: 15,
  ShowMoreButtonX: 40,
  ShowMoreButtonY: 25,

  TooltipOpacity: 0.7,
  TooltipMargin: 5,
  TooltipPadding: 5,

  FontFamily: 'monospace, monospace',
  FontSize: 15,
  FontStyle: 'normal',
  FontVariant: 'normal',
  FontStyleHeader: 'bold',
  FontSizeHeader: 18,
});
